import { Component, inject, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core'
import {
  combineLatest,
  distinctUntilChanged,
  map,
  Observable,
  startWith,
  Subject,
  take,
  takeUntil,
  tap
} from 'rxjs'
import { CommonModule, NgIf } from '@angular/common'
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms'
import { ActivatedRoute, RouterModule } from '@angular/router'
import { CapitalizePipe } from '../../pipes/capitalize.pipe'
import { BlockUnblockComponent } from '../template/block-unblock/block-unblock.component'
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap'
import { DeleteComponent } from '../template/delete/delete.component'
import { select, Store } from '@ngrx/store'
import { PaginationComponent } from '../template/pagination/pagination.component'
import { Business } from '../../store/business/business.state'
import { selectAllBusinesses } from '../../store/business/business.selectors'
import { loadBusinesses } from '../../store/business/business.actions'
import {
  selectActiveCount,
  selectAllUsers,
  selectInactiveCount,
  selectNewJoineeCount,
  selectTotalCount
} from '../../store/user/user.selectors'
import { AuthState, User } from '../../store/auth/auth.state'
import {
  blockEmployee,
  deleteEmployee,
  loadEmployees,
  createEmployee,
  createEmployeeSuccess,
  createEmployeeFailure,
  resetEmployeeState,
  blockEmployeeSuccess,
  blockEmployeeFailure
} from '../../store/user/user.actions'
import { environment } from '../../../environments/environment'
import { HasPermissionDirective } from '../../directives/has-permission.directive'
import { validateImage } from '../../utils/imageValidator'
import { Office } from '../../store/office/office.state'
import { selectDepartments } from '../../store/department/department.reducer'
import { Department } from '../../store/department/department.state'
import { selectOffices } from '../../store/office/office.reducer'
import { selectOfficeId } from '../../store/office/office.selectors'
import { selectDesignations } from '../../store/designation/designation.reducer'
import { Designation } from '../../store/designation/designation.state'
import { loadDepartments, resetDepartmentState } from '../../store/department/department.actions'
import { loadOffices, resetOfficeState } from '../../store/office/office.actions'
import {
  loadDesignations,
  resetDesignationState
} from '../../store/designation/designation.actions'
import { AuthService } from '../../services/auth.service'
import { DomSanitizer } from '@angular/platform-browser'
import {
  selectTotalDepartments,
  selectTotalDesignations,
  selectTotalOffices
} from '../../store/business/business.reducer'
import { NgSelectModule } from '@ng-select/ng-select'
import { Actions, ofType } from '@ngrx/effects'
import { StrictEmailDirective } from '../../directives/strict-email.directive'
import dayjs from 'dayjs'
import { TrimInputDirective } from '../../directives/trim-input.directive'
import { SharedModule } from '../../shared/shared.module'

@Component({
  selector: 'app-employee',
  imports: [
    ReactiveFormsModule,
    NgIf,
    CommonModule,
    RouterModule,
    CapitalizePipe,
    BlockUnblockComponent,
    FormsModule,
    DeleteComponent,
    PaginationComponent,
    HasPermissionDirective,
    NgSelectModule,
    StrictEmailDirective,
    TrimInputDirective,
    SharedModule
    // BrowserAnimationsModule
  ],
  templateUrl: './employee.component.html',
  styleUrl: './employee.component.scss'
})
export class EmployeeComponent implements OnInit, OnDestroy {
  private store = inject(Store) // Inject store using `inject()`
  @ViewChild('addBusinessModals') addBusinessModals!: TemplateRef<any>
  private modalRef!: NgbModalRef
  currentPage = 1
  pageLimit = 10
  loading$: Observable<boolean> = this.store.select(state => state.designation.loading)
  error$: Observable<string | null> = this.store.select(state => state.designation.error)
  pageLastRecord = 0
  form!: FormGroup
  businesses$: Observable<Business[]> = this.store.select(selectAllBusinesses)
  employees$!: Observable<User[]>
  employees!: User[]

  // designations$: Observable<Designation[]> = this.store.select(selectDesignations)
  // departments$: Observable<Department[]> = this.store.select(selectDepartments)
  totalCount$!: Observable<number>
  totalCount = 0
  activeCount$!: Observable<number>
  inactiveCount$!: Observable<number>
  newJoineeCount$!: Observable<number>
  activeCount = 0
  inactiveCount = 0
  newJoineeCount = 0
  search = ''
  blockEmployeeId = ''
  showModal = false
  showDeleteModal = false
  isBlocking!: boolean // Assuming this will be set before opening the modal
  selectedBusinessId = ''
  selectedDepartmentId = ''
  public defaultImg = '../../../../assets/img/user.jpg'
  public imagePath: any
  public imageURL: string | null = this.defaultImg
  public apiEndpoint = environment.apiBaseUrl
  currentStep = 1
  steps = [1, 2, 3, 4] // Steps for the form
  offices$!: Observable<Office[]>
  office$!: Observable<Office[]>
  officeId$!: Observable<string | null>
  officeId: string | null = null
  departments$: Observable<Department[]> = this.store.select(selectDepartments)
  designations$: Observable<Designation[]> = this.store.select(selectDesignations)
  public today: Date = new Date()
  public todayplussixmonths: any = dayjs().add(6, 'month').endOf('day')
  public maturedDate: Date = new Date()
  public todayDate = `${this.today.getUTCFullYear()}-${this.today.getUTCDay() + 1 < 10 ? '0' : ''}${this.today.getUTCDay() + 1}-${this.today.getUTCDate()}`
  maxDate = ''
  businessImages: Record<string, string> = {} // Ensure this is defined correctly
  user: AuthState['user'] | null = null
  businessIdss!: string[]
  officeCount$!: Observable<number>
  officeCount = 0
  departmentCount$!: Observable<number>
  departmentCount = 0
  designationCount$!: Observable<number>
  designationCount = 0
  createloading = false
  originalImageURL = ''

  private destroyed$ = new Subject<void>()
  portalAccess = true
  selectedBusiness$!: Observable<Business | undefined>
  status = false
  businessId!: string | null
  uniquePictures: string[] = []
  Math = Math
  //commented on 20 nov 2025
  constructor(
    private modalService: NgbModal,
    private fb: FormBuilder,
    private authService: AuthService,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private actions$: Actions
  ) {
    // this.store
    //   .select(selectUser)
    //   .pipe(take(1))
    //   .subscribe(user => {
    //     //this.user = user

    //     //this.selectedBusiness = user?.business?.id

    //     // this.businessList = user?.businesses
    //     //if (this.user?.role.name === 'Business Owner') {
    //     //  this.selectedBusinessOwner = this.user.businessOwnerId
    //     //}
    //     // this.getAttendancePolicyList()
    //     const businessIds = user?.businessIds // your array of business IDs
    //     // const paramString = `ids=${businessIds?.join(',') ?? ''}`;
    //     if (businessIds && businessIds.length) {
    //       this.businessIdss = businessIds

    //       // const paramString = `businessIds=${businessIds.join(',')}`
    //       // this.store.dispatch(loadBusinesses({ params: paramString }))
    //     } else {
    //       // this.loadAllBusinesses() // Load all businesses initially
    //       // this.loadEmployees()
    //       // this.loadAllBusinessOwners()
    //     }
    //   })
    // this.loadEmployees()
    // this.loadAllBusinesses()
    // this.store.dispatch(loadBusinesses({ params: null }))
    // this.employees$ = this.store.select(selectUsers) as Observable<User[]>

    this.employees$ = this.store.select(selectAllUsers)

    this.totalCount$ = this.store.select(selectTotalCount).pipe(
      map(totalCount => totalCount || 0) // Default to 0 if totalCount is null
    )
    this.activeCount$ = this.store.select(selectActiveCount).pipe(
      map(activeCount => activeCount || 0) // Default to 0 if totalCount is null
    )

    // Subscribe to totalCount$ safely
    this.activeCount$.subscribe(count => {
      this.activeCount = count // Define this.totalCount in your class
    })

    this.inactiveCount$ = this.store.select(selectInactiveCount).pipe(
      map(inactiveCount => inactiveCount || 0) // Default to 0 if totalCount is null
    )

    // Subscribe to totalCount$ safely
    this.inactiveCount$.subscribe(count => {
      this.inactiveCount = count // Define this.totalCount in your class
    })

    this.newJoineeCount$ = this.store.select(selectNewJoineeCount).pipe(
      map(newJoineeCount => newJoineeCount || 0) // Default to 0 if totalCount is null
    )

    // Subscribe to totalCount$ safely
    this.newJoineeCount$.subscribe(count => {
      this.newJoineeCount = count // Define this.totalCount in your class
    })

    this.officeCount$ = this.store.select(selectTotalOffices).pipe(
      map(officeCount => officeCount || 0) // Default to 0 if totalCount is null
    )
    this.officeCount$.subscribe(count => {
      this.officeCount = count // Define this.totalCount in your class
    })

    this.departmentCount$ = this.store.select(selectTotalDepartments).pipe(
      map(departmentCount => departmentCount || 0) // Default to 0 if totalCount is null
    )
    this.departmentCount$.subscribe(count => {
      this.departmentCount = count // Define this.totalCount in your class
    })
    this.designationCount$ = this.store.select(selectTotalDesignations).pipe(
      map(designationCount => designationCount || 0) // Default to 0 if totalCount is null
    )
    this.designationCount$.subscribe(count => {
      this.designationCount = count // Define this.totalCount in your class
    })

    this.offices$ = this.store.select(selectOffices)
    this.officeId$ = this.store.pipe(select(selectOfficeId))
    this.departments$ = this.store.select(selectDepartments)
    this.designations$ = this.store.select(selectDesignations)
  }

  ngOnInit() {
    this.maturedDate.setFullYear(this.today.getFullYear() - 18)
    this.maxDate = this.maturedDate.toISOString().split('T')[0] // Format as 'yyyy-MM-dd'
    // this.store.dispatch(loadEmployees({ params: null }))
    // this.store.select(selectAllUsers).subscribe(users => console.log(users))
    // this.store.select(selectAllUsers).subscribe(employees => {
    //   this.employees = employees
    //   employees.forEach(emp => {
    //     if (emp.picture && !this.businessImages[emp.picture]) {
    //       this.businessImage(emp.picture)
    //     }
    //   })
    // })
    // this.store.select(selectAllUsers).subscribe(employees => {
    //   this.employees = employees

    //   // Collect unique picture names
    //   const pictures = employees
    //     .map(emp => emp.picture) // array of string | null
    //     .filter((pic): pic is string => !!pic) // <-- only keep string values

    //   // Now, after all employees are fetched, trigger image fetches in parallel
    //   pictures.forEach(pic => this.businessImage(pic))
    // })

    //20nov2025
    this.loadEmployees()
    this.employees$
      .pipe(
        distinctUntilChanged(), // don't re-trigger unnecessarily
        tap(employees => {
          this.employees = employees // UI renders immediately
        }),
        map(employees => employees.map(e => e.picture).filter((p): p is string => !!p))
        // tap(pictures => {
        //   this.uniquePictures = [...new Set(pictures)]
        //   // this.loadAllBusinesses()
        // })
        // switchMap(pictures => {
        //   // load images lazily
        //   return forkJoin(pictures.map(pic => this.businessImage(pic))).pipe(
        //     catchError(() => of([])) // NEVER block UI
        //   )
        // })
      )
      .subscribe()

    setTimeout(() => this.loadAllBusinesses(), 0)
    // this.loadAllBusinesses()
    this.employees$.pipe(distinctUntilChanged()).subscribe(employees => {
      this.employees = employees

      // const pictures = [...new Set(employees.map(e => e.picture).filter((p): p is string => !!p))]

      // // 2️⃣ Load pictures only if not cached
      // pictures.forEach(pic => {
      //   if (!this.businessImages[pic]) {
      //     this.businessImage(pic)
      //   }
      // })
    })

    this.totalCount$.subscribe(count => {
      this.totalCount = count
      this.updatePageLastRecord()
    })

    this.form = this.fb.group({
      companyInfoForm: this.fb.group({
        firstName: ['', [Validators.required, Validators.maxLength(50)]],
        lastName: ['', [Validators.required, Validators.maxLength(50)]],
        email: ['', [Validators.required, Validators.email]],
        // personalEmail: ['', this.conditionalEmailValidator()],
        mobile: ['', [Validators.required, this.mobileNumberValidator()]],
        // personalMobile: ['', this.conditionalMobileValidator()],
        // birthdate: ['', [Validators.required, this.ageValidator(18)]],
        joiningDate: ['', [Validators.required]],
        businessId: ['', Validators.required],
        officeId: ['', Validators.required],
        departmentId: ['', Validators.required],
        designationId: ['', Validators.required],
        picture: [null],
        role: ['', Validators.required],
        gender: ['', Validators.required],
        // empId: ['', Validators.required]
        portalAccess: [true]
      }),
      rolepermissionInfoForm: this.fb.group({
        userRoleId: [''],
        permissions: ['']
      })
    })

    this.actions$
      .pipe(
        ofType(createEmployeeSuccess),
        takeUntil(this.destroyed$) // don't forget to clean up
      )
      .subscribe(() => {
        this.createloading = false
        this.form.reset()
        this.imageURL = this.defaultImg
        this.originalImageURL = ''
        this.modalService.dismissAll() // or modalRef.close() if you're using one
      })

    this.actions$
      .pipe(
        ofType(createEmployeeFailure),
        takeUntil(this.destroyed$) // don't forget to clean up
      )
      .subscribe(() => {
        this.createloading = false
      })

    this.selectedBusiness$ = combineLatest([
      this.businesses$,
      this.form
        .get('companyInfoForm.businessId')!
        .valueChanges.pipe(startWith(this.form.get('companyInfoForm.businessId')!.value)) // emit initial value if you want!
    ]).pipe(map(([businesses, selectedId]) => businesses.find(biz => biz.id === selectedId)))

    this.actions$
      .pipe(
        ofType(blockEmployeeSuccess, blockEmployeeFailure),
        takeUntil(this.destroyed$) // don't forget to clean up
      )
      .subscribe(() => {
        this.loadEmployees()
        // this.form.reset()
        // this.modalService.dismissAll() // or modalRef.close() if you're using one
      })
  }

  //20 nov 2025
  // constructor(
  //   private modalService: NgbModal,
  //   private fb: FormBuilder,
  //   private authService: AuthService,
  //   private sanitizer: DomSanitizer,
  //   private route: ActivatedRoute,
  //   private actions$: Actions
  //   // private store: Store
  // ) {}

  // ngOnInit() {
  //   this.setupForm()
  //   this.loadInitialData() // ✅ load user list + businesses
  //   this.subscribeToCounts() // ✅ single subscription for each count
  //   this.subscribeToEmployees() // ✅ employees render first → then images
  //   this.setupCreateEmployeeListeners()
  // }

  // /* --------------------- INITIAL LOAD --------------------- */

  // private loadInitialData() {
  //   this.loadEmployees()
  //   this.loadAllBusinesses()
  // }

  // /* --------------------- FORM SETUP ----------------------- */

  // private setupForm() {
  //   const maturedDate = new Date()
  //   maturedDate.setFullYear(maturedDate.getFullYear() - 18)
  //   this.maxDate = maturedDate.toISOString().split('T')[0]

  //   this.form = this.fb.group({
  //     companyInfoForm: this.fb.group({
  //       firstName: ['', [Validators.required, Validators.maxLength(50)]],
  //       lastName: ['', [Validators.required, Validators.maxLength(50)]],
  //       email: ['', [Validators.required, Validators.email]],
  //       mobile: ['', [Validators.required, this.mobileNumberValidator()]],
  //       joiningDate: ['', Validators.required],
  //       businessId: ['', Validators.required],
  //       officeId: ['', Validators.required],
  //       departmentId: ['', Validators.required],
  //       designationId: ['', Validators.required],
  //       picture: [null],
  //       role: [''],
  //       gender: ['', Validators.required],
  //       portalAccess: [true]
  //     }),
  //     rolepermissionInfoForm: this.fb.group({
  //       userRoleId: [''],
  //       permissions: ['']
  //     })
  //   })
  // }

  // /* --------------------- EMPLOYEE LIST --------------------- */

  // private subscribeToEmployees() {
  //   this.store
  //     .select(selectAllUsers)
  //     .pipe(
  //       distinctUntilChanged(),
  //       tap(users => {
  //         this.employees = users // 1️⃣ Employees render instantly
  //       }),
  //       map(users => [...new Set(users.map(u => u.picture).filter(Boolean))]), // unique pics
  //       switchMap(pictures =>
  //         forkJoin(
  //           pictures
  //             .filter((p): p is string => !!p) // remove null
  //             .map(pic => this.businessImage(pic))
  //         )
  //       )
  //     )
  //     .subscribe()
  // }

  // /* --------------------- COUNTS ---------------------------- */

  // private subscribeToCounts() {
  //   this.store.select(selectTotalCount).subscribe(v => (this.totalCount = v || 0))
  //   this.store.select(selectActiveCount).subscribe(v => (this.activeCount = v || 0))
  //   this.store.select(selectInactiveCount).subscribe(v => (this.inactiveCount = v || 0))
  //   this.store.select(selectNewJoineeCount).subscribe(v => (this.newJoineeCount = v || 0))
  //   this.store.select(selectTotalOffices).subscribe(v => (this.officeCount = v || 0))
  //   this.store.select(selectTotalDepartments).subscribe(v => (this.departmentCount = v || 0))
  //   this.store.select(selectTotalDesignations).subscribe(v => (this.designationCount = v || 0))
  // }

  // /* --------------------- SUCCESS / FAILURE ----------------- */

  // private setupCreateEmployeeListeners() {
  //   this.actions$.pipe(ofType(createEmployeeSuccess), takeUntil(this.destroyed$)).subscribe(() => {
  //     this.createloading = false
  //     this.form.reset()
  //     this.modalService.dismissAll()
  //   })

  //   this.actions$.pipe(ofType(createEmployeeFailure), takeUntil(this.destroyed$)).subscribe(() => {
  //     this.createloading = false
  //   })
  // }

  // ngAfterViewInit() {
  //   setTimeout(() => {
  //     this.employees$.subscribe(employees => {
  //       const pictures = [...new Set(employees.map(e => e.picture).filter((p): p is string => !!p))]

  //       pictures.forEach(pic => this.businessImage(pic))
  //     })
  //   })

  // }

  // ngAfterViewInit() {
  //   setTimeout(() => {
  //     this.loadAllBusinesses()
  //   }, 0)
  // }

  loadEmployees() {
    const params: any = {}
    // if (this.businessIdss?.length) {
    //   params.businessIds = this.businessIdss.join(',')
    // }
    // console.log('business ids', this.businessIdss)
    if (this.search) {
      // params.firstName = this.firstName
      params.search = this.search
    }

    // if (this.status) {
    params.disabled = this.status
    // }

    if (this.businessId) {
      params.businessId = this.businessId
    }

    this.store.dispatch(
      loadEmployees({
        params: new URLSearchParams(params).toString(),
        page: this.currentPage,
        limit: this.pageLimit
      })
    )
  }

  onSearch() {
    this.currentPage = 1 // Reset to the first page on search
    const params = this.search?.trim()
      ? `firstName=${encodeURIComponent(this.search)}&lastName=${encodeURIComponent(this.search)}&email=${encodeURIComponent(this.search)}`
      : ''

    this.store.dispatch(loadEmployees({ params, page: this.currentPage, limit: this.pageLimit })) // Dispatch action with filter
  }

  onPageChange(newPage: number): void {
    if (newPage > 0) {
      this.currentPage = newPage
      this.loadEmployees() // Reload businesses for the new page
      this.updatePageLastRecord()
    }
  }

  private updatePageLastRecord() {
    this.pageLastRecord = Math.min(this.currentPage * this.pageLimit, this.totalCount)
  }

  onPageLimitChange() {
    this.currentPage = 1 // Reset to first page when limit changes
    this.loadEmployees() // Load employees with new page limit
  }

  openModal(isBlocking: boolean, employeeId: string) {
    const modalRef = this.modalService.open(BlockUnblockComponent)
    modalRef.componentInstance.isBlocking = isBlocking
    modalRef.componentInstance.recordId = employeeId
    // this.blockBusinessId = businessId

    modalRef.result.then(
      result => {
        // Handle the result from the modal
        if (result) {
          // Call the service to update the business status
          this.handleConfirm(result)
        }
      },
      reason => {
        // Handle the dismiss case
        if (reason) {
          this.handleConfirm(reason)
        }
      }
    )
  }

  handleConfirm(data: { id: string; status: boolean }) {
    this.store.dispatch(blockEmployee({ id: data.id, disabled: data.status }))
  }

  openDeleteModal(employeeId: string) {
    const modalRef = this.modalService.open(DeleteComponent)
    modalRef.componentInstance.recordId = employeeId
    modalRef.result.then(
      result => {
        // Handle the result from the modal
        if (result) {
          // Call the service to update the business status
          this.handleDeleteConfirm(result)
        }
      },
      reason => {
        // Handle the dismiss case
        if (reason) {
          this.handleDeleteConfirm(reason)
        }
      }
    )
  }

  handleDeleteConfirm(data: { id: string }) {
    this.store.dispatch(deleteEmployee({ id: data.id }))
  }

  openBusinessModal(content: TemplateRef<any>, options: any = {}) {
    this.form.reset()
    this.imageURL = this.defaultImg
    this.originalImageURL = ''
    this.currentStep = 1
    this.modalRef = this.modalService.open(content, {
      scrollable: false,
      centered: true,
      size: 'lg',
      ...options
    })
  }

  onClose() {
    // if (this.form) {
    //   this.form.reset(); // Reset the form if it is defined
    // }
    // this.modalService.dismissAll();
    // this.currentStep = 1;

    try {
      if (this.form) {
        this.form.reset()
      }
      this.imageURL = this.defaultImg
      if (this.modalRef) {
        this.modalRef.close()
      }
      this.modalService.dismissAll()
      this.currentStep = 1
    } catch (error) {
      console.error('Error closing modal:', error)
    }
  }
  getErrorMessage(controlName: string): string | null {
    const control = this.form.get(controlName)
    // console.log('control name', control)
    if (control && control.touched && control.invalid) {
      if (control.hasError('required')) {
        return 'This field is required'
      }
      if (control.hasError('email')) {
        return 'Please enter a valid email address'
      }
      if (control.hasError('pattern')) {
        // Check if it's a URL pattern error for social media fields
        if (controlName.includes('facebook')) {
          return 'Please enter a valid Facebook URL'
        } else if (controlName.includes('twitter')) {
          return 'Please enter a valid Twitter URL'
        } else if (controlName.includes('linkedin')) {
          return 'Please enter a valid LinkedIn URL'
        } else if (controlName.includes('skype')) {
          return 'Please enter a valid Skype username or invite link'
        } else if (controlName.includes('whatsapp')) {
          return 'Please enter a valid WhatsApp link'
        } else if (controlName.includes('instagram')) {
          return 'Please enter a valid Instagram URL'
        } else if (controlName.includes('website')) {
          return 'Please enter a valid website URL'
        } else {
          return 'The entered value is not valid'
        }
      }
    }
    return null // No error
  }

  // Function to check if the current step is valid
  isStepValid(): boolean {
    switch (this.currentStep) {
      case 1:
        return !!this.form.get('businessInfoForm')?.valid
      case 2:
        return !!this.form.get('addressInfoForm')?.valid
      case 3:
        return !!this.form.get('socialInfoForm')?.valid

      default:
        return false
    }
  }

  // Function to go to the next step
  goToNextStep(): void {
    if (this.isStepValid()) {
      if (this.currentStep === 1) {
        // this.updateBusiness()
      }
      if (this.currentStep === 2) {
        // this.updateBusiness()
      }
      if (this.currentStep === 3) {
        // this.updateBusiness()
      }
      this.currentStep++
    } else {
      alert('Please complete the form before proceeding!')
    }
  }

  stepChange(newStep: number): void {
    if (
      this.isStepValid()
      // || this.isStepValidOfficeupdate()
    ) {
      this.currentStep = newStep
    }
  }

  onFileChange(event: Event, imageid: string) {
    const inputElement = event.target as HTMLInputElement
    if (inputElement.files && inputElement.files.length > 0) {
      const file = inputElement.files[0]
      const validationResult = validateImage(file)

      if (validationResult.valid) {
        // console.log('Image is valid!', file)
        this.form.get('companyInfoForm.picture')?.setValue(file) // Set the file in the form control
        // this.validationError = '' // Clear any previous error messages
      } else {
        console.error('Validation error:', validationResult.message)
        // this.validationError = validationResult.message // Set the error message
      }

      const reader = new FileReader()
      reader.onload = e => {
        if (imageid === 'imageURL') {
          this.imageURL = e.target?.result as string
        }
      }

      reader.readAsDataURL(file)
    }
  }

  onBusinessChange(businessId: string) {
    this.selectedBusiness$ // Observable<Business>
      .pipe(take(1))
      .subscribe(business => {
        const incDate = business?.incorporationDate
        const maxDate = this.todayplussixmonths
        const joiningDateControl = this.form.get('companyInfoForm.joiningDate')
        joiningDateControl?.setValidators([
          Validators.required,
          this.joiningDateWindowValidator(incDate, maxDate)
        ])
        joiningDateControl?.updateValueAndValidity()
      })
    if (businessId) {
      // Call a method to fetch data based on the selected owner
      const params = `businessId=${encodeURIComponent(businessId)}`

      this.store.dispatch(loadOffices({ params, page: this.currentPage, limit: this.pageLimit })) // Dispatch action with filter

      this.store.dispatch(
        loadDepartments({ params, page: this.currentPage, limit: this.pageLimit })
      ) // Dispatch action with filter
    } else {
      // const params = ''
      // this.store.dispatch(
      //   loadDepartments({ params, page: this.currentPage, limit: this.pageLimit })
      // )
      // Dispatch action with filter
      // Handle the case where no owner is selected
      // console.log('No business selected')
      this.store.dispatch(resetOfficeState())
      this.store.dispatch(resetDepartmentState())
      this.store.dispatch(resetDesignationState())
    }
  }

  onDepartmentChange(departmentId: string) {
    this.store.dispatch(resetDesignationState())
    if (departmentId) {
      // Call a method to fetch data based on the selected owner
      const params = `departmentId=${encodeURIComponent(departmentId)}`

      this.store.dispatch(
        loadDesignations({ params, page: this.currentPage, limit: this.pageLimit })
      ) // Dispatch action with filter
    } else {
      const params = ''
      this.store.dispatch(
        loadDesignations({ params, page: this.currentPage, limit: this.pageLimit })
      ) // Dispatch action with filter
      // Handle the case where no owner is selected
      // console.log('No business selected')
    }
  }

  // Custom validator for ownerpersonalPhone
  conditionalMobileValidator() {
    return (control: AbstractControl) => {
      if (control.value) {
        // Validate using your phoneNumberValidator if value exists
        return this.mobileNumberValidator()(control)
      }
      return null // No error if value is empty
    }
  }

  // Custom validator for ownerpersonalEmail
  conditionalEmailValidator() {
    return (control: AbstractControl) => {
      if (control.value) {
        // Validate using the email validator if value exists
        return Validators.email(control)
      }
      return null // No error if value is empty
    }
  }

  ageValidator(minAge: number): ValidatorFn {
    return (control: AbstractControl): Record<string, any> | null => {
      if (control.value) {
        const birthdate = new Date(control.value)
        const today = new Date()
        const age = today.getFullYear() - birthdate.getFullYear()
        const monthDifference = today.getMonth() - birthdate.getMonth()

        // Adjust age if the birthdate has not occurred yet this year
        if (
          monthDifference < 0 ||
          (monthDifference === 0 && today.getDate() < birthdate.getDate())
        ) {
          return age < minAge ? { ageInvalid: true } : null
        }

        return age < minAge ? { ageInvalid: true } : null
      } else {
        return null
      }
    }
  }

  mobileNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const mobileNumber = control.value
      // const valid = /^\+\d{1,14}$/.test(phoneNumber); // Adjust the regex as needed
      // const valid = /^\+\d{1,3}[\s()\-]?\d{1,14}([\s()\-]?\d{1,4})*$/.test(phoneNumber);
      // const valid = /^\+\d{1,3} \d{1,14}$/.test(phoneNumber);
      const valid = /^\+\d{1,3}[\s]?\d{1,14}$/.test(mobileNumber)

      return valid ? null : { invalidMobileNumber: true }
    }
  }

  onSubmit() {
    if (this.form.valid) {
      this.createloading = true
      this.store.dispatch(
        createEmployee({
          payload: this.form.value // or pass individual fields
        })
      )
      // const formData = new FormData()

      // formData.append('firstName', this.form.get('companyInfoForm.firstName')?.value)
      // formData.append('lastName', this.form.get('companyInfoForm.lastName')?.value)

      // formData.append('email', this.form.get('companyInfoForm.email')?.value)
      // formData.append('personalEmail', this.form.get('companyInfoForm.personalEmail')?.value)

      // formData.append('mobile', this.form.get('mobile')?.value)
      // formData.append('personalMobile', this.form.get('companyInfoForm.personalMobile')?.value)
      // formData.append('birthdate', this.form.get('companyInfoForm.birthdate')?.value)
      // formData.append('joiningDate', this.form.get('companyInfoForm.joiningDate')?.value)
      // formData.append('businessId', this.form.get('companyInfoForm.businessId')?.value)
      // formData.append('officeId', this.form.get('companyInfoForm.officeId')?.value)
      // formData.append('designationId', this.form.get('companyInfoForm.designationId')?.value)
      // formData.append('empId', this.form.get('companyInfoForm.empId')?.value)
      // formData.append('gender', this.form.get('companyInfoForm.gender')?.value)

      // const picture = this.form.get('picture')?.value
      // if (picture) {
      //   formData.append('picture', picture)
      // }

      // let userId = ''
      // this.store.pipe(select(selectUser), take(1)).subscribe(user => {
      //   if (user && user.id) {
      //     console.log(user)
      //     // formData.append('userId', user.id)
      //     userId = user.id
      //   } else {
      //     // Handle the case where the user is null or doesn't have an ID
      //     console.error('User is not logged in or ID is missing.')
      //     // You could throw an error, or handle this scenario as needed
      //   }
      // })

      // this.store.dispatch(
      //   createEmployee({
      //     firstName: this.form.get('companyInfoForm.firstName')?.value,
      //     lastName: this.form.get('companyInfoForm.lastName')?.value,

      //     email: this.form.get('companyInfoForm.email')?.value,
      //     personalEmail: this.form.get('companyInfoForm.personalEmail')?.value,

      //     mobile: this.form.get('mobile')?.value,
      //     personalMobile: this.form.get('companyInfoForm.personalMobile')?.value,
      //     birthdate: this.form.get('companyInfoForm.birthdate')?.value,
      //     joiningDate: this.form.get('companyInfoForm.joiningDate')?.value,
      //     businessId: this.form.get('companyInfoForm.businessId')?.value,
      //     officeId: this.form.get('companyInfoForm.officeId')?.value,
      //     designationId: this.form.get('companyInfoForm.designationId')?.value,
      //     empId: this.form.get('companyInfoForm.empId')?.value,
      //     gender: this.form.get('companyInfoForm.gender')?.value
      //   })
      // )
    }
  }

  businessImage(picture: string) {
    const imageUrl = this.apiEndpoint + '/uploads/' + picture // Assuming this is the correct path
    this.authService.getImage(imageUrl).subscribe(
      imageBlob => {
        // console.log('asdf', imageBlob)
        const objectURL = URL.createObjectURL(imageBlob)
        this.businessImages[picture] = objectURL // Store the object URL
      },
      error => {
        console.error('Error fetching image:', error)
      }
    )
  }

  loadAllBusinesses() {
    const params: any = {}
    // if (this.businessIdss?.length) {
    //   params.businessIds = this.businessIdss.join(',')
    // }
    params.disabled = false

    // if (this.search) {
    //   params.businessName = this.search
    // }

    // if (this.businessOwner) {
    //   params.ownerId = this.businessOwner
    // }

    this.store.dispatch(
      loadBusinesses({
        params: new URLSearchParams(params).toString()
        // page: this.currentPage,
        // limit: this.pageLimit
      })
    )

    // if (this.businessIdss && this.businessIdss.length) {
    //   const paramString = `businessIds=${this.businessIdss.join(',')}`
    //   this.store.dispatch(
    //     loadBusinesses({ params: paramString, page: this.currentPage, limit: this.pageLimit })
    //   )
    // } else {
    //   this.store.dispatch(
    //     loadBusinesses({ params: null, page: this.currentPage, limit: this.pageLimit })
    //   ) // Load all businesses
    //   this.loadAllBusinessOwners()
    // }
  }

  onImageError(employee: any): void {
    employee.picture = null // fallback triggers initials
  }

  getInitials(firstName: string = '', lastName: string = ''): string {
    const firstInitial = firstName?.charAt(0) || ''
    const lastInitial = lastName?.charAt(0) || ''
    return (firstInitial + lastInitial).toUpperCase()
  }

  customSearchFn = (term: string, item: any) => {
    const fullName = item && item.businessName ? item.businessName.toLowerCase() : ''
    return fullName.includes(term ? term.toLowerCase() : '')
  }

  togglePortalAccess() {
    this.portalAccess = !this.portalAccess
  }

  ngOnDestroy(): void {
    this.store.dispatch(resetEmployeeState())

    this.destroyed$.next()
    this.destroyed$.complete()
  }

  joiningDateWindowValidator(
    incorporationDate: string | Date | undefined | null,
    maxDate: string | Date | undefined
  ): ValidatorFn {
    return (control: AbstractControl) => {
      const joiningDate = control.value ? dayjs(control.value) : null
      const incDate = incorporationDate ? dayjs(incorporationDate) : null
      const max = maxDate ? dayjs(maxDate) : null

      if (
        !joiningDate ||
        !incDate ||
        !joiningDate.isValid() ||
        !incDate.isValid() ||
        !max?.isValid()
      ) {
        return null
      }

      if (joiningDate.isBefore(incDate, 'day')) {
        return { joiningBeforeIncorporation: true }
      }
      if (joiningDate.isAfter(max, 'day')) {
        return { joiningTooLate: true }
      }
      return null
    }
  }

  setCurrentPage() {
    this.currentPage = 1
  }
}
